import { Component, OnInit , Output, EventEmitter } from '@angular/core';
import { LoanProgram , AssignmentStrategy} from '../loanprogram.model';
import { Product } from '../Product.model';
import { LoanProgramService, } from '../loanprogram.service';
import { OrderByField } from '../../users/user-details/orderByField.pipe';
@Component({
  selector: 'app-program-list',
  templateUrl: './program-list.component.html',
  styleUrls: ['./program-list.component.css']
})
export class ProgramListComponent implements OnInit {
   public programs: LoanProgram[] = [];
  @Output() updated = new EventEmitter<any>();

  constructor(private loanProgramService: LoanProgramService) {

  }

  ngOnInit() {
    this.loanProgramService.getLoanPrograms()
      .then(result => this.programs = result);
      this.loanProgramService.programAdded
        .subscribe((program: LoanProgram) => {
          this.programs.push(program);
      });
    this.loanProgramService.programUpdated
      .subscribe((program: LoanProgram) => {
        this.programs.find(x => x.id === program.id).name = program.name;
        this.programs.find(x => x.id === program.id).products = program.products;
        this.programs.find(x => x.id === program.id).loanProgramAssignmentStrategies = program.loanProgramAssignmentStrategies;
        this.programs.find(x => x.id === program.id).loanChannelId = program.loanChannelId;
        this.updated.emit(false);
      });
    this.loanProgramService.programDeleted
      .subscribe((programId: string) => {
        var programsIndex = this.programs.findIndex(t => t.id === programId);
        this.programs.splice(programsIndex, 1);
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/program-list/program-list.component.ts